module.exports = __webpack_public_path__ + "static/media/id.1cfe4160.svg";